<template>

    <div class="v-application v-application--is-ltr theme--light">

        <v-card elevation="24">

            <v-card-title class="text-h6">
                {{ title || 'Update' }}
            </v-card-title>

            <v-card-text v-if="message">
                {{ message || 'Are you sure that you would like to perform this action?' }}
            </v-card-text>

            <v-card-text v-if="disclaimer" style="color: black; padding-top: 0px;">
                {{ disclaimer || 'By selecting Confirm, you are authorizing this action to be taken' }}
            </v-card-text>

            <v-card-actions>
                <v-btn color="primary" @click="confirm">
                    {{ confirmText || 'Confirm' }}
                </v-btn>
                <v-btn color="red" text @click="close">
                    {{ cancelText || 'Cancel' }}
                </v-btn>
            </v-card-actions>

        </v-card>

    </div>

</template>

<script>
export default {
    props: ["title", "message", "disclaimer", "cancelText", "confirmText", "onConfirm", "keyData"],
    data() {
        return {}

    },
    methods: {

        close() {
            this.$emit('close');
        },

        async confirm() {
            try {
                if (!this.onConfirm) {
                    this.close();
                    return;
                }
                await this.onConfirm();
            } catch (e) {
                console.error(e)
            } finally {
                this.close();
            }

        },
        getMinimumDateForKeys() {
            const date = new Date();
            const offsetDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
            const formatted = offsetDate.toISOString().slice(0, 16);
            return formatted
        },
        formatDate(date) {
            const offsetDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
            const formatted = offsetDate.toISOString().slice(0, 16);
            return formatted
        }

    }

};
</script>

<style scoped>
.vuetify-modal-wrapper {
    background: transparent;
}

.edit-date-input-section {
    padding-left: 1em;
    padding-right: 1em;
    padding-bottom: 1em;
}
</style>